export default __webpack_public_path__ + "static/media/ep19.132da779.jpeg";